import { Injectable } from '@angular/core';
import { CanActivate, CanDeactivate, CanLoad, Route, Router, UrlSegment } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../shared/services/auth.service';
import { BrowserStorageService } from '../shared/services/common/browser-storage.service';

// Interface to ensure the component implements a canDeactivate method
export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ProfileGuard implements CanActivate, CanLoad {
  constructor(
    private _router: Router,
    private _auth: AuthService,
    private _storage: BrowserStorageService,
  ) {}

  canActivate(): boolean {
    const isAuthenticated = this._auth.profileAuth();
    if (!this._storage.getCookie('authToken')) {
      this._router.navigate(['/auth/login']);
      return false;
    }
    if (!isAuthenticated) {
      this._router.navigate(['/']);
      return false;
    }
    return true;
  }

  canLoad(route: Route, segments: UrlSegment[]): boolean | Observable<boolean> {
    const isAuthenticated = this._auth.profileAuth();
    if (!isAuthenticated) {
      this._router.navigate(['/']);
      return false;
    }
    return true;
  }
}

export class PreventNavigationGuard implements CanDeactivate<CanComponentDeactivate> {
  canDeactivate(component: CanComponentDeactivate): Observable<boolean> | Promise<boolean> | boolean {
    return component.canDeactivate ? component.canDeactivate() : true;
  }
}
